<!-- Threads feed -->
<div class="thp">
  <div class="thp-post">
    <img class="thp-avatar" [src]="avatar" alt="" />
    <div class="thp-body">
      <div class="thp-header">
        <span class="thp-name">{{ accountName }}</span>
        <span class="thp-label">Oglas</span>
        <i class="bi bi-three-dots thp-menu"></i>
      </div>

      <div class="thp-text">{{ primaryText.text }}</div>
      <div class="thp-more" *ngIf="primaryText.truncated">… more</div>

      <a class="thp-card" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
        <app-meta-creative [src]="data.creative" [kind]="data.creativeKind" slot="feed"></app-meta-creative>
        <div class="thp-card-copy">
          <div class="thp-domain">{{ domain }}</div>
          <div class="thp-headline">{{ headline }}</div>
        </div>
      </a>

      <div class="thp-actions">
        <i class="bi bi-heart"></i>
        <i class="bi bi-chat"></i>
        <i class="bi bi-arrow-repeat"></i>
        <i class="bi bi-send"></i>
      </div>
    </div>
  </div>

  <!-- The next post in the feed, left empty -->
  <div class="thp-next"></div>
</div>
